import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('edit-youtube-video', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['viewport']),
  },
  data() {
    return {
      newSrc: '',
    };
  },
  name: 'edit-youtube-video',
  props: ['droplet', 'show-edit-bubble'],
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.newSrc = this.droplet.youTubeLink;
    },
    updateSrc() {
      this._debounce(() => {
        if (this.newSrc !== '' && this.newSrc) {
          this.$vnode.context.updateSrc(this.newSrc, this.droplet.autoplay);
        }
      }, 200);
    },
    setAutoplay(e) {
      const autoplay = e.currentTarget.checked;
      if (autoplay) {
        this.$vnode.context.updateSrc(this.droplet.youTubeLink, true);
      } else {
        this.$vnode.context.updateSrc(this.droplet.youTubeLink, false);
      }
      const payload = {};
      payload.drp = this.droplet;
      payload.autoplay = autoplay;
      this.$store.dispatch('setYoutubeAutoPlay', payload);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.$emit('css-generator');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/youtube-video/components/_edit-options/index.js